import { get } from '@/utils/http'

/** 管理端按 App 筛选：加载 /admin/app/list，searchAppId 为空表示全部。 */
export default {
  data() {
    return {
      appOptions: [],
      appsLoading: false,
      searchAppId: null
    }
  },
  methods: {
    async loadAppOptions() {
      this.appsLoading = true
      try {
        const result = await get('/admin/app/list')
        this.appOptions = Array.isArray(result.data) ? result.data : []
      } catch (e) {
        this.appOptions = []
      } finally {
        this.appsLoading = false
      }
    },
    appendAppIdParam(params) {
      if (this.searchAppId != null && this.searchAppId !== '') {
        params.appId = this.searchAppId
      }
      return params
    },
    appOptionLabel(app) {
      return (app.name || '未命名') + '（' + (app.packageName || '未配置包名') + '）'
    }
  }
}
